import { CSSProperties } from '@mui/styles/withStyles';

const DEFAULT_SPACING = 4;

const OverrideTheme = {
  colors: {
    primary: '#136CAC',
    background: '#f7f7f7',
    cardBackground: '#fff',
    actual: '#E40521',
    actualLight: '#feeef0',
    border: '#E3E3E3',
    warning: '#E86826',
    success: '#27A579',
    error: '#B80025',
    info: '#1D91C3',
    textPrimary: '#272727',
    textDisable: '#545352',
    notification: '#23956D',
  },
  shadows: {
    default: 'none',
    menu: '0 4px 4px 0 rgba(0, 0, 0, 0.04)',
    primary: '1px 1px 2px 0 #dedadac2',
  },
  icon: {
    defaultColor: '#136CAC',
    defaultWidth: '1em',
    defaultHeight: '1em',
    defaultVariant: 'outlined',
    defaultType: 'regular',
    defaultSize: 'regular',
  },

  getSpacing: (length: number): number => DEFAULT_SPACING * length,
  font: {
    size: {
      h1: DEFAULT_SPACING * 2,
      h2: DEFAULT_SPACING * 1.5,
    },
  },
  ui: {
    headerPrimary: (): CSSProperties => ({
      background: OverrideTheme.colors.background,
      color: OverrideTheme.colors.textPrimary,
    }),
    lightCard: (): CSSProperties => ({
      backgroundColor: OverrideTheme.colors.cardBackground,
      borderRadius: '5px',
      boxShadow: OverrideTheme.shadows.primary,
      height: 'fit-content',
    }),
  },
};

export default OverrideTheme;
